export const story = {
  id: 1358216,
  brand_id: 73,
  title: "Don't Miss RNR 13",
  type: 'barstool_original',
  url: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13',
  branch_url: 'https://bars.tl/1358216',
  thumbnail: {
    type: 'large',
    location: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/',
    images: {
      small: 'thumbnail.jpg',
      medium: 'thumbnail.jpg',
      large: 'thumbnail.jpg'
    },
    desktop:
      'https://chumley.barstoolsports.com/union/2020/12/22/uh-oh.5fd50aaf.jpg?canvas=560%3A420&bg-color=000000&width=560',
    raw: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/thumbnail.jpg',
    raw_desktop:
      'https://chumley.barstoolsports.com/union/2020/12/22/uh-oh.5fd50aaf.jpg?canvas=560%3A420&bg-color=000000',
    featured: null,
    raw_featured: null
  },
  nsfw: false,
  comment_count: 0,
  comment_status_open: true,
  category: [
    {
      id: '98',
      slug: 'newyork',
      name: 'New York'
    }
  ],
  tag: 'Barstool Original',
  tags: [],
  author: {
    name: 'Morrison',
    avatar:
      'https://chumley.barstoolsports.com/union/2020/02/05/acd081bb.jpg?crop=320%3A320%2Csmart&width=64&height=64',
    author_url: '/bio/103435/morrison/morrison',
    id: 103435,
    has_notifications: true,
    is_active: true
  },
  post_type_meta: {
    standard_post: {
      raw_content: '<p> </p>',
      content:
        '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,shrink-to-fit=no"><title>Don&#39;t Miss RNR 13</title><script src="https://d9rde3y35j061.cloudfront.net/script.js"></script><script src="https://iframely.barstoolsports.com/embed.js" async></script><style>.union__content{font-family:-apple-system,HelveticaNeue,Roboto,sans-serif;font-weight:400;font-size:18px;color:#5a5b5d;word-wrap:break-word;box-sizing:border-box;padding:0 5px 32px 5px}.union__content p{padding:0;margin:16px 0 0 0}.union__content img{display:block!important;width:100%!important;height:auto;margin:16px 0 0 0}.union__content video{display:block!important;width:100%!important;height:auto;margin:16px 0 0 0}.union__content .ym{margin:16px 0 0 0}.union__content p a{color:#377dc4}.union__content .oembed__wrapper{margin:16px 0 0 0}.union__content blockquote:not(.twitter-video){display:block;margin:16px 0 0 0;padding:4px 12px;border-left:4px solid #77889a;font-style:italic;background:#f0f4f8;text-align:left;border-radius:0 6px 6px 0}.union__content blockquote:not(.twitter-video) p{font-style:italic}.union__content blockquote,q{quotes:none}.union__content iframe{max-width:100%}.union__content .bs-image-hidden{display:none}.union__content div.hq-image{width:fit-content;margin:0 auto}.union__content span.image-attribution,.union__content span.image-attribution a{color:#757575;font-size:12px;font-style:italic;letter-spacing:.1px;line-height:14px;text-decoration:none;padding:0;margin:0}.union__content .bs-videoPlayer .bs-videoPlayer__container,.union__content video-js,.wp-video{width:100%!important;height:0!important;position:relative;padding-bottom:56.25%;overflow:hidden;margin:16px 0 0 0}.wp-video video{width:100%!important;height:100%!important}.hq-image video{width:100%!important;height:100%!important}.union__content .bs-videoPlayer__container>iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none}@media (prefers-color-scheme:dark){.union__content,body,html{background:#1c1c1c;color:#f1f1f1}.union__content blockquote:not(.twitter-video){border-left:4px solid #367dc4;background:#272c35}}</style><script>window.addEventListener(\'applicationDidBecomeActive\', () => {\n        const videos = document.querySelectorAll(\'.hq-image video[autoplay]\')\n        videos.forEach((video) => video.play())\n      })</script></head><body class="union__content"><p> </p></body></html>'
    },
    barstool_original: {
      id: '89jFH4y6hHRYkdrC9CnRNT',
      duration: 165632,
      type: 'barstool',
      pre_roll_disabled: false,
      image: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/thumbnail.jpg',
      show: {
        id: '98',
        title: 'New York',
        slug: 'newyork',
        image: null
      },
      site_iframe_url:
        'https://union-staging.barstoolsports.com/v2/video/standard/a266511d-40a8-4b16-8b18-af47518758b4/1358216'
    },
    podcast: null,
    gallery: null,
    live: null,
    fundraiser: null
  },
  product: {
    id: null
  },
  campaign: null,
  viewability: 0,
  is_pinned: 0,
  is_featured: 0,
  is_published: 1,
  is_hidden: 0,
  is_show_guide: 0,
  is_membership: 0,
  is_archive: 0,
  is_search_indexed: 1,
  gated_product_id: null,
  access_level: 0,
  ads_disabled: 0,
  is_featured_section: 0,
  blocker_description: '',
  is_instant_article: 0,
  brand_name: "Rough N' Rowdy",
  author_is_active: 1,
  is_gold: false,
  date: '2021-01-07T17:37:34.000Z',
  slug: 'dont-miss-rnr-13',
  hidden_tags: [],
  sites: {
    barstoolsports: true,
    barstoolbets: false
  },
  urls: {
    barstoolsports: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13',
    barstoolbets: 'https://www-staging.barstoolbets.com/videos/1358216/dont-miss-rnr-13',
    canonical: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13'
  },
  sharing: {
    facebook: {
      title: "Don't Miss RNR 13",
      url: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13'
    },
    twitter: {
      title: "Don't Miss RNR 13",
      url: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13'
    },
    sms: {
      title: "Don't Miss RNR 13",
      url: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13'
    },
    email: {
      title: "Don't Miss RNR 13",
      url: 'https://www.barstoolsports.dev/video/1358216/dont-miss-rnr-13'
    }
  },
  updated_at: '2021-01-09T00:14:20.000Z'
}

export const storyVideoSource = {
  duration: 165632,
  playback_id: 'V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP',
  sources: [
    {
      type: 'application/x-mpegURL',
      src: 'https://stream.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP.m3u8'
    },
    {
      width: null,
      height: null,
      master: true,
      src: 'https://chumley.barstoolsports.com/union/2020/12/17/GARY-V_-Twitter.7d172961.mp4',
      type: 'video/mp4'
    },
    {
      width: 640,
      height: 360,
      master: false,
      src: 'https://stream.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/low.mp4',
      type: 'video/mp4'
    },
    {
      width: 960,
      height: 540,
      master: false,
      src: 'https://stream.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/medium.mp4',
      type: 'video/mp4'
    },
    {
      width: 1920,
      height: 1080,
      master: false,
      src: 'https://stream.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/high.mp4',
      type: 'video/mp4'
    },
    {
      width: null,
      height: null,
      master: false,
      src: 'https://chumley.barstoolsports.com/temp/a576087c-fd25-4bc9-a848-ef10abca4618.mp3',
      type: 'audio/mpeg'
    }
  ],
  poster_sources: [
    {
      src: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/thumbnail.jpg'
    }
  ],
  poster: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/thumbnail.jpg',
  cue_points: [
    {
      name: null,
      id: '7bb59d12',
      type: 'AD',
      time: 0
    },
    {
      name: 'Opening',
      id: '31ac5de3',
      time: 0,
      type: 'CHAPTER'
    },
    {
      name: 'Taxes?',
      id: '226eb270',
      time: 29.984,
      type: 'CHAPTER'
    },
    {
      name: 'Where Does Gary Vee Stand on Bitcoin?',
      id: '9be17b84',
      time: 36.807,
      type: 'CHAPTER'
    },
    {
      name: 'Is God real?',
      id: 'dfaa87c7',
      time: 60.092,
      type: 'CHAPTER'
    },
    {
      name: 'Is Gary Vee a thot?',
      id: '017793c0',
      time: 84.726,
      type: 'CHAPTER'
    },
    {
      name: "Cursing doesn't fucking matter",
      id: 'c2303417',
      time: 136.687,
      type: 'CHAPTER'
    },
    {
      name: null,
      id: '8251cb6a',
      type: 'AD',
      time: 165.632
    }
  ],
  cue_points_vtt: {
    chapters: 'https://union-staging.barstoolsports.com/v2/media/89jFH4y6hHRYkdrC9CnRNT/chapters.vtt',
    ads: 'https://union-staging.barstoolsports.com/v2/media/89jFH4y6hHRYkdrC9CnRNT/ads.vtt'
  },
  text_tracks: [
    {
      closed_captions: false,
      type: 'text',
      text_type: 'subtitles',
      status: 'ready',
      name: 'English',
      language_code: 'en',
      id: '8uiYM01CTUi1BvGZVi8CL6UHeiSzmRBMOdMFnHf6fpXWcH13NaENvug',
      src: 'https://chumley.barstoolsports.com/union/2021/01/07/4590fe36d2de.vtt'
    }
  ],
  advertising: {
    enabled: false
  },
  media_tags: [],
  storyboard: {
    vtt: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/storyboard.vtt',
    json: 'https://image.mux.com/V02Uz02kNZtOdCAyS02tkqM7sJ5TbM02lSOP/storyboard.json'
  },
  id: '89jFH4y6hHRYkdrC9CnRNT',
  name: "Don't Miss RNR 13",
  tags: [],
  published_at: '2021-01-07T17:37:34.000Z',
  updated_at: '2021-01-07T17:37:34.000Z',
  thumbnail:
    'https://chumley.barstoolsports.com/union/2020/12/22/uh-oh.5fd50aaf.jpg?canvas=560%3A420&bg-color=000000&width=560',
  thumbnail_sources: [
    {
      src:
        'https://chumley.barstoolsports.com/union/2020/12/22/uh-oh.5fd50aaf.jpg?canvas=560%3A420&bg-color=000000&width=560'
    }
  ],
  gam: {
    cmsId: '2536742'
  }
}
